export default "__VITE_ASSET__BQlIZZ02__"